import { motion } from "framer-motion";

/**
 * StaggerText — splits a string into words and reveals them with stagger.
 * Use for headlines that need a cinematic word-by-word entrance.
 */
export const StaggerText = ({
  text,
  className = "",
  wordClassName = "",
  stagger = 0.08,
  delay = 0,
  as = "h1",
  "data-testid": testId,
}) => {
  const Component = motion[as] || motion.h1;
  const words = text.split(" ");

  return (
    <Component
      className={className}
      data-testid={testId}
      initial="hidden"
      animate="show"
      variants={{
        hidden: {},
        show: {
          transition: {
            staggerChildren: stagger,
            delayChildren: delay,
          },
        },
      }}
    >
      {words.map((word, i) => (
        <motion.span
          key={`${word}-${i}`}
          className={`inline-block mr-[0.25em] ${wordClassName}`}
          variants={{
            hidden: { opacity: 0, y: 32, filter: "blur(8px)" },
            show: {
              opacity: 1,
              y: 0,
              filter: "blur(0px)",
              transition: { duration: 0.95, ease: [0.16, 1, 0.3, 1] },
            },
          }}
        >
          {word}
        </motion.span>
      ))}
    </Component>
  );
};

export default StaggerText;
